module.exports = __webpack_public_path__ + "static/img/company-left.0e5085f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home/company-left.jpg
// module id = KFN0
// module chunks = 0